module.exports = __webpack_public_path__ + "static/media/reqService.375dcdeb.png";